// App.jsx
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home        from "./pages/Home";
import Forum       from "./pages/Forum";
import Category    from "./pages/Category";
import NewThread   from "./pages/NewThread";
import Thread      from "./pages/Thread";
import Profile     from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import MyProfileRedirect from "./components/MyProfileRedirect";
import Login       from "./pages/Login";
import Register    from "./pages/Register";
import Admin       from "./pages/Admin";
import About       from "./pages/About";
import NotFound from "./pages/NotFound";

export default function App() {
    return (
        <AuthProvider>
            <Navbar />
            <main>
                <Routes>
                    {/* Public */}
                    <Route path="/"                   element={<Home />} />
                    <Route path="/forum"              element={<Forum />} />
                    <Route path="/forum/:categoryId"  element={<Category />} />
                    <Route path="/thread/:threadId"   element={<Thread />} />
                    <Route path="/profile/:accountId" element={<Profile />} />
                    <Route path="/login"              element={<Login />} />
                    <Route path="/register"           element={<Register />} />
                    <Route path="/about"              element={<About />} />

                    {/* Requires login */}
                    <Route element={<ProtectedRoute />}>
                        <Route path="/profile"               element={<MyProfileRedirect />} />
                        <Route path="/profile/edit"          element={<EditProfile />} />
                        <Route path="/forum/:categoryId/new" element={<NewThread />} />
                    </Route>

                    {/* Requires admin */}
                    <Route element={<ProtectedRoute requiredRole="admin" />}>
                        <Route path="/admin" element={<Admin />} />
                    </Route>

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>
            <Footer />
        </AuthProvider>
    );
}